// tslint:disable:no-commented-code
// tslint:disable:no-console
// tslint:disable:no-any
import { enableProdMode } from '@angular/core';
// tslint:disable-next-line:nx-enforce-module-boundaries
import { environmentSettings } from '@epicuro-next/platform/environment';
// tslint:disable-next-line:nx-enforce-module-boundaries
import { lazyLoadTranslations } from '@epicuro-next/platform/i18n';
import { initSentry } from '@epicuro-next/platform/sentry';
import 'hammerjs';

import { UNPROTECTED_RESOURCES } from './app/auth/unprotected-resources';
import { environment } from './environments/environment';

const FAILED_TO_LOAD_ENV_ERROR = 'FAILED_TO_LOAD_ENV_ERROR';
const FAILED_TO_LOCALE_ERROR = 'FAILED_TO_LOCALE_ERROR';

if (environment.production) {
  enableProdMode();
}

/**
 * Need to know environment setting even before bootstrap so Pulse behave correctly
 * Known dependencies:
 *  1. AuthenticationService needs to know where to store sessionId. It cannot re-set
 * storage place after the creation.
 */
export const loadEnvironmentSettings = async (retryOnFailCount = 5) => {
  let envSettings;

  do {
    try {
      const envSettingsResponse = await fetch(
        UNPROTECTED_RESOURCES.ENVIRONMENT_API,
      );
      envSettings = await envSettingsResponse.json();
      retryOnFailCount = -1;
    } catch {
      if (retryOnFailCount > 0) {
        retryOnFailCount = retryOnFailCount - 1;
      } else {
        throw Error(FAILED_TO_LOAD_ENV_ERROR);
      }
    }
  } while (retryOnFailCount >= 0);

  // side effect, so we update setting object that is used in application
  Object.assign(environmentSettings, envSettings);
};

async function loadEnvironmentAndStartSentry() {
  await loadEnvironmentSettings(5);

  // According to sentry documentations, it's best to initialize sentry before angular
  const { sentryDsn } = environmentSettings;
  if (sentryDsn) initSentry(sentryDsn, environmentSettings); // don't await!
}

async function init() {
  try {
    // All three run in parallel: the translations + env fetches, and the
    // (tiny) bootstrap chunk — requesting it also injects a preload link for
    // the (large) app-module chunk, so that downloads in parallel too (the
    // webpackPreload hint only works from a non-entry chunk, see bootstrap.ts).
    // Evaluation of the app module happens inside bootstrapApp(), strictly
    // AFTER translations resolve — module-level $localize constants must not
    // evaluate earlier, or they capture LoclString boxed objects (breaks
    // TitleCasePipe NG02100, NgRx serializability).
    const [{ bootstrapApp }] = await Promise.all([
      import('./bootstrap'),
      lazyLoadTranslations().catch(() => {
        return Promise.reject(new Error(FAILED_TO_LOCALE_ERROR));
      }),
      loadEnvironmentAndStartSentry(),
    ]);

    await bootstrapApp();
  } catch (err) {
    if (
      err instanceof Error &&
      (err.message === FAILED_TO_LOAD_ENV_ERROR ||
        err.message === FAILED_TO_LOCALE_ERROR)
    ) {
      alert(
        'Something went wrong. Please try to reload your page or contact your customer service',
      );
    }
  }
}

init();
